function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import Button from 'components/Form/Button';
import Plus from 'svg/plus.svg';
import App from 'modules/App';
import * as constants from '../../constants';
import messages from '../../messages';
import styles from './AddPatientBtn.pcss';
var _React_PureComponent;
class AddPatientBtn extends (_React_PureComponent = React.PureComponent) {
    renderButtonContent() {
        const plus = /*#__PURE__*/ _jsx(Plus, {
            className: styles.icon
        });
        return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.buttons.addPatient), {
            values: {
                plus
            }
        }));
    }
    render() {
        return /*#__PURE__*/ _jsx(Button, {
            styleModifier: "transparent",
            className: cn(styles.root, this.props.className),
            onClick: ()=>this.props.onOpenModal(),
            children: this.renderButtonContent()
        });
    }
}
_define_property(AddPatientBtn, "propTypes", {
    // Explicit props
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    // Implicit actions
    onOpenModal: PropTypes.func
});
const mapDispatchToProps = (dispatch)=>({
        onOpenModal: ()=>dispatch(App.actions.openModal(constants.INVITE_PATIENT_MODAL))
    });
const ConnectedAddPatientBtn = connect(null, mapDispatchToProps)(AddPatientBtn);
export default withStyles(styles)(ConnectedAddPatientBtn);
